import { Navigation } from 'components/common-form/builder/form/node/field/Grid/GridField.model';
import { KeyboardEvent, useCallback } from 'react';

export function useOnKeyDownWithCanEdit(
  onNavigated: (navigation: Navigation) => void,
  onEditionStarted?: (lostEvent?: KeyboardEventInit) => void,
  shouldStartEditionByKey?: (key: string) => boolean,
) {
  return useCallback(
    (canEdit: boolean) => (e: KeyboardEvent<HTMLInputElement>) => {
      switch (e.key) {
        case 'ArrowLeft':
          onNavigated('left');
          break;
        case 'ArrowRight':
          onNavigated('right');
          break;
        case 'ArrowUp':
          onNavigated('up');
          break;
        case 'ArrowDown':
          onNavigated('down');
          break;
        case 'Tab':
          onNavigated('next');
          break;
        case 'Enter':
        case ' ':
          if (canEdit) {
            onEditionStarted?.();
          }
          break;
        default:
          if (canEdit && shouldStartEditionByKey?.(e.key)) {
            const lostEvent: KeyboardEventInit = {
              key: e.nativeEvent.key,
              code: e.nativeEvent.code,
              altKey: e.nativeEvent.altKey,
              ctrlKey: e.nativeEvent.ctrlKey,
              shiftKey: e.nativeEvent.shiftKey,
            };
            onEditionStarted?.(lostEvent);
          }
          break;
      }
      e.preventDefault();
    },
    [onEditionStarted, onNavigated, shouldStartEditionByKey],
  );
}
